var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMsg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3333 9.83255C19.3367 11.1524 19.0283 12.4544 18.4333 13.6325C17.7277 15.0443 16.643 16.2317 15.3007 17.0618C13.9584 17.8919 12.4115 18.3319 10.8333 18.3325C9.51338 18.336 8.21137 18.0276 7.03325 17.4325L1.33325 19.3325L3.23325 13.6325C2.63818 12.4544 2.32981 11.1524 2.33325 9.83255C2.33386 8.25431 2.77386 6.7074 3.60397 5.3651C4.43408 4.0228 5.62151 2.93812 7.03325 2.23255C8.21137 1.63748 9.51338 1.32911 10.8333 1.33255H11.3333C13.4176 1.44754 15.3863 2.32731 16.8624 3.80341C18.3385 5.2795 19.2183 7.2482 19.3333 9.33255V9.83255Z",
    stroke: "#666666",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsg);
export default __webpack_public_path__ + "static/media/msg.ce1e183f23bee393bb35e86f39b02c8b.svg";
export { ForwardRef as ReactComponent };